import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "href", "className", "label", "size", "isAccent", "isWhite", "isGray", "isDark", "accent", "white", "gray", "darkMode", "full", "leftIcon", "rightIcon", "children"],
  _excluded2 = ["htmlProps"],
  _excluded3 = ["htmlProps"],
  _excluded4 = ["htmlProps"],
  _excluded5 = ["htmlProps"];
import { forwardRef } from 'react';
import cn from 'classnames';
import parseClassnames from "../../helpers/parseClassnames";
import ButtonWithLabelChildren from "../ButtonWithLabelChildren";
import { BUTTON_SIZES, BUTTON_SIZES_WITH_ICON } from "../classnames";
import { jsx as _jsx } from "react/jsx-runtime";
var PrimaryButton = function PrimaryButton(_ref, ref) {
  var as = _ref.as,
    href = _ref.href,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    label = _ref.label,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    isAccent = _ref.isAccent,
    isWhite = _ref.isWhite,
    isGray = _ref.isGray,
    isDark = _ref.isDark,
    accent = _ref.accent,
    white = _ref.white,
    gray = _ref.gray,
    darkMode = _ref.darkMode,
    full = _ref.full,
    leftIcon = _ref.leftIcon,
    rightIcon = _ref.rightIcon,
    children = _ref.children,
    primaryButtonProps = _objectWithoutProperties(_ref, _excluded);
  var buttonTypeClassNames = isDark || darkMode ? 'button-primary-dark' : 'button-primary';
  if (isGray || gray) {
    buttonTypeClassNames = 'button-primary-gray';
  }
  if (isWhite || white) {
    buttonTypeClassNames = 'button-primary-white';
  }
  if (isAccent || accent) {
    buttonTypeClassNames = 'button-primary-convertion';
  }
  var wrapperClassName = parseClassnames(className, cn(leftIcon !== null && leftIcon !== void 0 && leftIcon.component || rightIcon !== null && rightIcon !== void 0 && rightIcon.component ? BUTTON_SIZES_WITH_ICON[size] : BUTTON_SIZES[size], buttonTypeClassNames, isDark || darkMode ? 'button-dark' : 'button-light', {
    'w-full': full
  }));
  var renderChildren = function renderChildren() {
    return /*#__PURE__*/_jsx(ButtonWithLabelChildren, {
      label: label,
      leftIcon: leftIcon,
      rightIcon: rightIcon,
      defaultIconSize: size === 'xs' ? 16 : 24,
      children: children
    });
  };
  if (as === 'a' || href) {
    var _ref2 = primaryButtonProps,
      _htmlProps = _ref2.htmlProps,
      aProps = _objectWithoutProperties(_ref2, _excluded2);
    return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      href: href,
      className: wrapperClassName
    }, _htmlProps), aProps), {}, {
      children: renderChildren()
    }));
  }
  if (as === 'label') {
    var _ref3 = primaryButtonProps,
      _htmlProps2 = _ref3.htmlProps,
      labelProps = _objectWithoutProperties(_ref3, _excluded3);
    return /*#__PURE__*/_jsx("label", _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      className: wrapperClassName
    }, _htmlProps2), labelProps), {}, {
      children: renderChildren()
    }));
  }
  if (as === 'span') {
    var _ref4 = primaryButtonProps,
      _htmlProps3 = _ref4.htmlProps,
      spanProps = _objectWithoutProperties(_ref4, _excluded4);
    return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      className: wrapperClassName
    }, _htmlProps3), spanProps), {}, {
      children: renderChildren()
    }));
  }
  var _ref5 = primaryButtonProps,
    htmlProps = _ref5.htmlProps,
    buttonProps = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    type: "button",
    className: wrapperClassName
  }, htmlProps), buttonProps), {}, {
    children: renderChildren()
  }));
};
export default /*#__PURE__*/forwardRef(PrimaryButton);